import { useCallback, useMemo } from 'react';
import { SurveyFeedItem } from '../../models/data';
import { useAppDispatch, useAppSelector } from '../../store';
import { feedActions } from '../../store/actions';

export const useSurveyFeedItems = () => {
  const dispatch = useAppDispatch();
  const { surveyFeedItems } = useAppSelector((state) => state.feed);

  const pendingSurveys = useMemo((): SurveyFeedItem[] => {
    return surveyFeedItems.filter((s) => s.completedAt === null);
  }, [surveyFeedItems]);

  const completeSurvey = useCallback(
    async (surveyId: string) => {
      await dispatch(feedActions.completeSurvey(surveyId)).unwrap();
    },
    [dispatch]
  );

  return { surveyFeedItems: pendingSurveys, completeSurvey };
};
